export default __webpack_public_path__ + "static/media/toolbar-underline.e92fed1d.svg";